/*
 * Emballage cadeau + carte (système Et Hop).
 * Case « C'est pour offrir ? » dans le panier (page /cart et tiroir), fenêtre de choix de la carte et
 * du message, ajout au panier de la variante choisie avec ses propriétés. Données : window.HopEmballage
 * (snippets/emballage-cadeau.liquid).
 */
(function () {
  'use strict';
  var C = window.HopEmballage;
  if (!C || !C.cartes || !C.cartes.length) return;
  var MAX_MESSAGE = 300, MAX_NOM = 60;
  var etat = { ligne: null };   // ligne « emballage » du panier (ou null)
  var PRODUITS = C.cartes.map(function (c) { return c.produit; });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Pendant une commande groupée, pas d'emballage cadeau.
  function enCommandeGroupee() { try { return !!JSON.parse(localStorage.getItem('hopCommandeGroupee') || 'null'); } catch (e) { return false; } }

  function lirePanier() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        etat.ligne = (panier.items || []).filter(function (i) { return PRODUITS.indexOf(i.handle) !== -1 || (i.properties && i.properties._emballage); })[0] || null;
        return panier;
      });
  }

  // --- Case dans le panier ---------------------------------------------------
  function caseHtml() {
    var l = etat.ligne;
    var detail = l ? '<span class="hop-ec-case__detail">' + esc(l.variant_title || '') +
      (l.properties && l.properties.Destinataire ? ' · pour ' + esc(l.properties.Destinataire) : '') +
      ' · <button type="button" class="hop-ec-case__modifier" data-hop-ec-modifier>Modifier</button></span>' : '';
    return '<input type="checkbox" data-hop-ec-case' + (l ? ' checked' : '') + '>' +
      '<span>C’est pour offrir ? Ajoutez une carte et un emballage cadeau' + detail + '</span>';
  }

  function placer() {
    var conteneurs = document.querySelectorAll('.cart__ctas');
    Array.prototype.forEach.call(conteneurs, function (ctas) {
      var parent = ctas.parentNode;
      var existante = parent.querySelector(':scope > .hop-ec-case');
      if (enCommandeGroupee()) { if (existante) existante.remove(); return; }
      if (!existante) {
        existante = document.createElement('label');
        existante.className = 'hop-ec-case';
        // tout en haut du récapitulatif, au-dessus du widget de fidélité et du total
        parent.insertBefore(existante, parent.firstChild);
      }
      var html = caseHtml();
      if (existante.getAttribute('data-html') !== html) { existante.innerHTML = html; existante.setAttribute('data-html', html); }
    });
  }

  document.addEventListener('click', function (e) {
    var modifier = e.target.closest && e.target.closest('[data-hop-ec-modifier]');
    if (modifier) { e.preventDefault(); ouvrir(); return; }
  });
  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-hop-ec-case]');
    if (!c) return;
    if (c.checked) { c.checked = !!etat.ligne; ouvrir(); }
    else if (etat.ligne) {
      if (!confirm('Retirer l’emballage cadeau et la carte ?')) { c.checked = true; return; }
      changerPanier({ id: etat.ligne.key, quantity: 0 }, '/cart/change.js');
    }
  });

  // --- Fenêtre de choix ------------------------------------------------------
  var fond = null;
  function fermer() { if (fond) { fond.remove(); fond = null; document.removeEventListener('keydown', echap); } }
  function echap(e) { if (e.key === 'Escape') fermer(); }

  function ouvrir() {
    fermer();
    var l = etat.ligne, p = (l && l.properties) || {};
    var choisie = l ? l.variant_id : null;
    fond = document.createElement('div');
    fond.className = 'hop-ec-fond';
    fond.innerHTML =
      '<div class="hop-ec-fenetre" role="dialog" aria-modal="true" aria-labelledby="hop-ec-titre">' +
        '<div class="hop-ec-tete"><h2 id="hop-ec-titre">Choisissez votre carte</h2><button type="button" class="hop-ec-fermer" aria-label="Fermer" data-hop-ec-fermer>×</button></div>' +
        '<form class="hop-ec-corps" data-hop-ec-form novalidate>' +
          '<div class="hop-ec-cartes">' +
          C.cartes.map(function (c, i) {
            return '<label class="hop-ec-carte"><input type="radio" name="carte" value="' + c.id + '"' +
              ((choisie ? choisie === c.id : i === 0) ? ' checked' : '') + '>' +
              '<span class="hop-ec-carte__image">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="hop-ec-carte__titre">' + esc(c.titre) + '</span>' +
              '<span class="hop-ec-carte__prix">' + (c.prix_barre ? '<s>' + esc(c.prix_barre) + '</s> ' : '') + esc(c.prix) + '</span></label>';
          }).join('') +
          '</div>' +
          '<p class="hop-ec-note">🎁 Votre commande sera livrée directement dans un <strong>emballage cadeau</strong>, avec votre carte, <strong>sans bon de commande ni facture</strong>.</p>' +
          '<div class="hop-ec-champs">' +
            '<label>De la part de<input name="de" maxlength="' + MAX_NOM + '" placeholder="De la part de" value="' + esc(p['De la part de'] || '') + '"></label>' +
            '<label>Destinataire<input name="pour" maxlength="' + MAX_NOM + '" placeholder="Destinataire" value="' + esc(p.Destinataire || '') + '"></label>' +
            '<label class="hop-ec-large">Message<textarea name="message" maxlength="' + MAX_MESSAGE + '" placeholder="Message">' + esc(p.Message || '') + '</textarea>' +
              '<span class="hop-ec-compte" data-hop-ec-compte></span></label>' +
          '</div>' +
        '</form>' +
        '<div class="hop-ec-pied"><span class="hop-ec-erreur" data-hop-ec-erreur role="alert"></span>' +
          '<button type="button" class="hop-ec-confirmer" data-hop-ec-confirmer>Confirmer</button></div>' +
      '</div>';
    document.body.appendChild(fond);
    document.addEventListener('keydown', echap);
    var form = fond.querySelector('[data-hop-ec-form]');
    var compte = fond.querySelector('[data-hop-ec-compte]');
    var maj = function () { compte.textContent = form.message.value.length + ' / ' + MAX_MESSAGE; };
    form.message.addEventListener('input', maj); maj();
    fond.addEventListener('click', function (e) { if (e.target === fond || e.target.closest('[data-hop-ec-fermer]')) fermer(); });
    fond.querySelector('[data-hop-ec-confirmer]').addEventListener('click', function () { confirmer(form, this); });
    setTimeout(function () { var r = form.querySelector('input[name=carte]:checked'); if (r) r.focus(); }, 30);
  }

  function confirmer(form, bouton) {
    var erreur = fond.querySelector('[data-hop-ec-erreur]');
    var carte = form.querySelector('input[name=carte]:checked');
    if (!carte) { erreur.textContent = 'Choisissez une carte.'; return; }
    var props = { _emballage: '1' };
    var de = form.de.value.trim(), pour = form.pour.value.trim(), message = form.message.value.trim();
    if (de) props['De la part de'] = de;
    if (pour) props.Destinataire = pour;
    if (message) props.Message = message;
    bouton.disabled = true; bouton.textContent = 'Ajout…'; erreur.textContent = '';
    // Modification : l'ancienne carte est remplacée par la nouvelle.
    var avant = etat.ligne ? fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: etat.ligne.key, quantity: 0 })
    }) : Promise.resolve();
    avant.then(function () {
      return changerPanier({ items: [{ id: Number(carte.value), quantity: 1, properties: props }] }, '/cart/add.js');
    }).then(fermer, function () {
      bouton.disabled = false; bouton.textContent = 'Confirmer';
      erreur.textContent = 'La carte n’a pas pu être ajoutée. Réessayez.';
    });
  }

  // --- Mise à jour du panier puis du thème (tiroir Dawn/Studio, sinon rechargement) ---
  function changerPanier(corps, url) {
    var tiroir = document.querySelector('cart-drawer');
    var avecTiroir = tiroir && typeof tiroir.renderContents === 'function' && location.pathname.indexOf('/cart') !== 0;
    if (avecTiroir) {
      corps.sections = tiroir.getSectionsToRender().map(function (s) { return s.id; });
      corps.sections_url = location.pathname;
    }
    return fetch(url, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) {
      if (!r.ok) throw new Error('panier');
      return r.json();
    }).then(function (rep) {
      if (avecTiroir && rep.sections) {
        tiroir.classList.contains('is-empty') && tiroir.classList.remove('is-empty');
        tiroir.renderContents(rep);
        return lirePanier().then(placer);
      }
      location.reload();
    });
  }

  // --- Démarrage : le panier du thème se re-dessine en AJAX ---------------------
  function rafraichir() { lirePanier().then(placer).catch(function () {}); }
  var attente = null;
  var ZONE_PANIER = 'cart-drawer, cart-drawer-items, cart-items, .cart__footer, #main-cart-footer, #CartDrawer';
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (!t.closest || t.closest('.hop-ec-case') || t.closest('.hop-ec-fond')) continue;
      if (!t.closest(ZONE_PANIER) && !(t.querySelector && t.querySelector('.cart__ctas'))) continue;
      clearTimeout(attente); attente = setTimeout(rafraichir, 250); return;
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rafraichir); else rafraichir();
})();
